// removed by extract-text-webpack-plugin
module.exports = {"Panel":"_3FQaFq9m-OWL2SuNkfeFNx","PanelOpen":"bJrSAi6jb-i3Wr7RszEk2","ContentShift":"_2i-heShhmHDpE_NBFOxMF6","ContentShiftOpen":"_2O7K6aiABfA8CEFWHeDnyG","Header":"_1Pofek0LgfCSjHke2T8xSM","Title":"_29JE3qreP0K4GGXoVB5TnD","CloseBtn":"CfvRxipNq5xxP3Ug0yaua","Body":"_1kDB245qRvPgeh2xpKMsAS"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Utils/FilterPanel/styles.module.css
// module id = 588
// module chunks = 0